import Form from 'react-bootstrap/Form';

function OrganizerInformationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  edit = false,
}) {
  return (
    <>
      <Form.Group controlId="name" className="mt-2">
        <Form.Label>Klubbnamn</Form.Label>
        <Form.Control
          type="text"
          value={values?.name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange klubbnamn"
          isInvalid={!!errors?.name}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.name}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="organizationNumber" className="mt-2">
        <Form.Label>Organisationsnummer</Form.Label>
        <Form.Control
          type="text"
          value={values?.organizationNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange organisationsnummer"
          isInvalid={!!errors?.organizationNumber}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.organizationNumber}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="district" className="mt-2">
        <Form.Label>Distrikt</Form.Label>
        <Form.Select
          value={values?.district}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!errors?.district}
        >
          <option value="none" hidden>
            Välj ett distrikt
          </option>
          <option value="Gotlands BF">Gotlands BF</option>
          <option value="Göteborgs BF">Göteborgs BF</option>
          <option value="Mellan Norrlands BF">Mellan Norrlands BF</option>
          <option value="Nedre Norra BF">Nedre Norra BF</option>
          <option value="Smålands BF">Smålands BF</option>
          <option value="Stockholms BF">Stockholms BF</option>
          <option value="Söder-/ Västmanlands BF">
            Söder-/ Västmanlands BF
          </option>
          <option value="Södra BF">Södra BF</option>
          <option value="Upplands BF">Upplands BF</option>
          <option value="Västra BF">Västra BF</option>
          <option value="Östergötland BF">Östergötland BF</option>
          <option value="Övre Norra BF">Övre Norra BF</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          {errors?.district}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId="swishNumber" className="mt-2">
        <Form.Label>Swish-nummer (Ej obligatoriskt)</Form.Label>
        <Form.Control
          type="text"
          value={values?.swishNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Ange Swish-nummer"
          isInvalid={!!errors?.swishNumber}
        />
        <Form.Control.Feedback type="invalid">
          {errors?.swishNumber}
        </Form.Control.Feedback>
      </Form.Group>
      {!edit ? (
        <>
          <Form.Group controlId="email" className="mt-2">
            <Form.Label>Klubbadmin</Form.Label>
            <Form.Control
              type="email"
              value={values?.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Ange e-post"
              isInvalid={!!errors?.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors?.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="password" className="mt-2">
            <Form.Label>Lösenord</Form.Label>
            <Form.Control
              type="password"
              value={values?.password}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Ange lösenord"
              isInvalid={!!errors?.password}
            />
            <Form.Control.Feedback type="invalid">
              {errors?.password}
            </Form.Control.Feedback>
          </Form.Group>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default OrganizerInformationSection;
